export const MachineCategoryDefaultColumnTypes = {
  machineName: {value: 'machineName', label: 'Machine name'},
  gatewayConnectivity: {value: 'gatewayConnectivity', label: 'Gateway connectivity'},
  trafficLightStatus: {value: 'trafficLightStatus', label: 'Traffic Light Status'},
  tag: {value: 'tag', label: 'Tag'},
  organization: {value: 'organization', label: 'Organization'}
};